export default __webpack_public_path__ + "static/media/confirmationImg.06d5030b.svg";